import { useCallback } from 'react';
import { useSnackbar } from 'notistack';

export function useCopyToClipboard(): (value: string, label?: string) => void {
  const { enqueueSnackbar } = useSnackbar();

  return useCallback(
    (value: string, label?: string) => {
      void navigator.clipboard.writeText(value).then(
        () => {
          enqueueSnackbar(`${label ?? 'Value'} copied to clipboard`, { variant: 'success' });
        },
        () => {
          enqueueSnackbar('Failed to copy', { variant: 'error' });
        },
      );
    },
    [enqueueSnackbar],
  );
}
